import React from 'react'
import {StyleSheet, View} from 'react-native'
import {Trans} from '@lingui/macro'
import {useNavigation} from '@react-navigation/native'
import {type NativeStackScreenProps} from '@react-navigation/native-stack'

import {type CommonNavigatorParams, type NavigationProp} from '#/lib/routes/types'
import {atoms as a, useTheme} from '#/alf'
import {Button, ButtonText} from '#/components/Button'
import {Check_Stroke2_Corner0_Rounded as CheckIcon} from '#/components/icons/Check'
import * as Layout from '#/components/Layout'
import {Text} from '#/components/Typography'

type Props = NativeStackScreenProps<CommonNavigatorParams, 'PremiumCancelled'>

export function PremiumCancelledScreen({}: Props) {
  const t = useTheme()
  const navigation = useNavigation<NavigationProp>()

  const handleGoHome = React.useCallback(() => {
    navigation.navigate('Home')
  }, [navigation])

  return (
    <Layout.Screen>
      <Layout.Content>
        <View style={[a.flex_1, a.justify_center, a.align_center, a.p_xl, styles.container]}>
          <View style={[styles.iconContainer, {backgroundColor: t.palette.positive_100}]}>
            <CheckIcon size="xl" style={{color: t.palette.positive_600}} />
          </View>

          <Text style={[a.text_2xl, a.font_bold, a.text_center, a.mt_xl, t.atoms.text]}>
            <Trans>Subscription Cancelled</Trans>
          </Text>

          <Text style={[a.text_lg, a.text_center, a.mt_md, t.atoms.text_contrast_medium]}>
            <Trans>Your subscription has been cancelled successfully.</Trans>
          </Text>

          <Button
            label="Go to Home"
            onPress={handleGoHome}
            size="large"
            variant="solid"
            color="primary"
            style={[a.rounded_md, a.mt_xl, styles.button]}>
            <ButtonText>
              <Trans>Go to Home</Trans>
            </ButtonText>
          </Button>
        </View>
      </Layout.Content>
    </Layout.Screen>
  )
}

const styles = StyleSheet.create({
  container: {
    minHeight: 400,
  },
  iconContainer: {
    width: 80,
    height: 80,
    borderRadius: 40,
    justifyContent: 'center',
    alignItems: 'center',
  },
  button: {
    minWidth: 200,
  },
})
